import React from 'react';

const LockIcon = ({ size = 33, ...props }) => (
  <svg
    width={Math.round((size * 24) / 22)}
    height={size}
    viewBox='0 0 24 22'
    fill='currentColor'
    {...props}>
    <path d='M19.0363 18.4035L18.4792 21.0342H-1.20122e-05L2.23047 10.5097H4.86982L3.19649 18.4035H19.0363ZM23.908 7.87714L22.7937 13.1403L21.6775 18.4035H19.0363L20.7096 10.5097H4.86982L5.42696 7.87714H8.06445L8.42771 6.28612C9.17419 2.76062 12.5393 0 16.0895 0C17.8776 0 19.4378 0.703614 20.4805 1.98274C21.5326 3.27487 21.9194 5.04411 21.5389 6.83935L21.304 7.87714H23.908ZM10.7429 7.87714H18.6256L18.987 6.28612C19.207 5.24833 19.0196 4.29966 18.4598 3.61275C17.9281 2.95926 17.0911 2.5991 16.1076 2.5991C13.8147 2.5991 11.4665 4.541 10.9797 6.83935L10.7429 7.87714Z' />
  </svg>
);

export default LockIcon;
